/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import dayjs from 'dayjs';
import { useCallback, useEffect } from 'react';
import { DateRangePicker, Form, MessagePlugin, Select, SelectOption, SelectValue, TimeRangePicker } from 'tdesign-react';
import FormItem from 'tdesign-react/es/form/FormItem';

import { FormArrayComponent } from '@/components/form/materials/Struct/formInputArray/form-array';
import { ISchedule, ScheduleType } from '@/store/modules/__endpoints__/module';

import styles from './index.module.less';

interface IProps {
  onChange: (value: ISchedule) => void;
  value: ISchedule;
  disabled: boolean;
}

const ItemComp: React.FC<IProps> = (props) => {
  const { value, disabled, onChange } = props;

  const [form] = Form.useForm();

  const handleChange1 = useCallback((val: SelectValue<SelectOption>) => {
    if (Number(val) === ScheduleType.SCHEDULE_TYPE_DAILY) {
      onChange({
        ...value, scheduleType: Number(val), startTime: { date: '', moment: value.startTime.moment },
        endTime: { date: '', moment: value.endTime.moment },
      });
    } else {
      onChange({
        ...value, scheduleType: Number(val),
      });
    }
  }, [value, onChange]);

  const handleChange2 = useCallback((val: any) => {
    onChange({
      ...value, startTime: { date: val[0].split(' ')[0], moment: val[0].split(' ')[1] },
      endTime: { date: val[1].split(' ')[0], moment: val[1].split(' ')[1] },
    });
  }, [value, onChange]);

  const handleChange3 = useCallback((val: any) => {
    if (dayjs(`2024-08-12 ${val[0]}`) >= dayjs(`2024-08-12 ${val[1]}`)) {
      onChange({ ...value });
      MessagePlugin.error('结束时间必须大于开始时间');
      return;
    }
    onChange({ ...value, startTime: { date: '', moment: val[0] }, endTime: { date: '', moment: val[1] } });
  }, [value, onChange]);

  const handleChange4 = useCallback((val: string[]) => {
    onChange({ ...value, fixedReplies: val });
  }, [value, onChange]);

  useEffect(() => {
    form.setFieldsValue({
      scheduleType: value.scheduleType,
      time: value.scheduleType === ScheduleType.SCHEDULE_TYPE_ONCE ? [`${value.startTime.date} ${value.startTime.moment}`, `${value.endTime.date} ${value.endTime.moment}`] : [`${value.startTime.moment}`, `${value.endTime.moment}`],
      fixedReplies: value.fixedReplies,
    });
  }, [value, form]);

  return (
    <Form form={form} labelAlign='top' className={styles.root} >
      <div className={styles.wrapper1}>
        <FormItem label='任务类型' name='scheduleType' style={{ width: '100%' }} >
          <Select options={[{ value: 1, label: '单次' }, { value: 2, label: '每日' }]} disabled={disabled} onChange={handleChange1} />
        </FormItem>
      </div>
      {value.scheduleType === ScheduleType.SCHEDULE_TYPE_ONCE && <div className={styles.wrapper2}>
        <FormItem name='time' style={{ width: '100%' }} label='时间范围' >
          <DateRangePicker style={{ width: '100%' }} enableTimePicker disabled={disabled} format='YYYY-MM-DD HH:mm:ss' onChange={handleChange2} />
        </FormItem>
      </div>}
      {value.scheduleType === ScheduleType.SCHEDULE_TYPE_DAILY && <div className={styles.wrapper2}>
        <FormItem name='time' style={{ width: '100%' }} label='时间范围' >
          <TimeRangePicker style={{ width: '100%' }} disabled={disabled} format='HH:mm:ss' onChange={handleChange3} />
        </FormItem>
      </div>}
      <div className={styles.wrapper3}>
        <FormItem name='fixedReplies' label='回复内容'>
          <FormArrayComponent
            hasOperation={false}
            fieldname='fixedReplies'
            value={value.fixedReplies}
            drag={true} buttonSize='small'
            onChange={handleChange4}
            config={undefined}
            getFieldDecorator={undefined}
            fieldsConfig={[]}
            form={undefined} />
        </FormItem>
      </div>
    </Form>
  );
};

export default ItemComp;
